import { Mutex } from 'async-mutex';

/**
 * Synchronization mutex. We could be a lot more granular as to what we lock, but this is good
 * enough.
 *
 * @internal
 */
export const mutex = new Mutex();
